module.exports = __webpack_public_path__ + "static/homer291-31dde845d0a72ab5d24a2bf5cba4d0a8.jpg";